<template>
  <div>
    <h-btn flat @click="display=true">Copy</h-btn>
    <modal v-if="display" 
      :title="'Copy ' + habitProgram.name" 
      @close="display=false"
      @submit="save"
      btn="Copy">

      <h-input type="text" v-model="newProgram.name" required label="New Name" />
      <h-input type="checkbox" v-model="newProgram.move_clients" label="Move All Clients Over" />
      <v-alert :value="saving" type="info">Saving this may take a few minutes</v-alert>
  </modal>
</div>
</template>

<script>
import modal from "@/components/modal/default";
import axios from "axios";
import snackbar from "@/services/hubs/snackbar";

export default {
  props: ["habitProgram"],
  components: {
    modal
  },
  data() {
    return {
      display: false,
      newProgram: {
        move_clients: true
      },
      saving: false
    };
  },
  methods: {
    save() {
      this.saving = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}coaches/habit-programs/${
            this.habitProgram.id
          }/copy_program/`,
          this.newProgram
        )
        .then(() => {
          snackbar.update("Saved");
          this.$router.replace(`/habit-programs`);
          this.display = false;
        })
        .finally(() => (this.saving = false));
    }
  }
};
</script>
